module.exports = __webpack_public_path__ + "static/media/book3.66d0d416.svg";